
import XButton from 'vux/src/components/x-button/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import qs from 'qs'

export default {
components: {
XButton, Msg, Divider
},
data() {
const query = qs.parse(location.search.slice(1))

return {
code: query.code || this.$route.query.code,
msg: query.data || this.$route.query.data,
title: '访问失败'
}
},
computed: {
description() {
if(this.code && this.msg) {
const div = document.createElement("div");
div.appendChild(document.createTextNode(this.msg));
return div.innerHTML;
} else {
return '该网址可能出了些差错，请稍后重试'
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/NotFoundComponent/index.vue